import { isDevelopmentMode, methods, sendRequest } from "../base";
import { convertObjectToQueryString } from "../../utils/convertObjToQueryString";

export const getTradeOffers = (
  offered_price = null,
  offered_price__gte = null,
  offered_price__lte = null,
  offered_quantity = null,
  offered_quantity_lte = null,
  offered_quantity_gte = null,
  ordering = null
) => {
  let params = {};
  if (offered_price) {
    params.offered_price = offered_price;
  }
  if (offered_price__gte) {
    params.offered_price__gte = offered_price__gte;
  }
  if (offered_price__lte) {
    params.offered_price__lte = offered_price__lte;
  }
  if (offered_quantity) {
    params.offered_quantity = offered_quantity;
  }
  if (offered_quantity_lte) {
    params.offered_quantity_lte = offered_quantity_lte;
  }
  if (offered_quantity_gte) {
    params.offered_quantity_gte = offered_quantity_gte;
  }
  if (offered_quantity_lte) {
    params.ordering = ordering;
  }
  const hasProperty = Object.keys(params).length > 0 ? true : false;
  let queryString = "";
  if (hasProperty) {
    queryString = convertObjectToQueryString(params);
  }
  return sendRequest(
    isDevelopmentMode()
      ? "/market-trades/offers" + (hasProperty ? "?" + queryString : "")
      : "/trade/offer/"
  );
};
export const submitOfferRequest = (
  type = null,
  offered_quantity = null,
  offered_price = null,
  commodity_id = 1
) => {
  const params = {
    type: type,
    offered_quantity: offered_quantity,
    offered_price: offered_price,
    commodity: Number(commodity_id),
  };
  return sendRequest(
    isDevelopmentMode() ? "/market-trades/offers" : "/trade/offer/",
    methods.POST,
    params
  );
};
export const submitTradeRequest = (
  cash_amount = null,
  gold_amount = null,
  commodity_id = 1,
  request_key = null
) => {
  const formData = new FormData();
  if (cash_amount) {
    formData.append("cash_amount", Math.ceil(cash_amount));
  }
  if (gold_amount) {
    formData.append("gold_amount", gold_amount);
  }
  if (request_key) {
    formData.append("request_key", request_key);
  }
  formData.append("commodity", commodity_id);
  return sendRequest(
    isDevelopmentMode() ? "/wallets/tsh-trades" : "/trade/offer/",
    methods.POST,
    formData
  );
};
export const cancelTradeRequest = (id, status = 3) => {
  return sendRequest(
    isDevelopmentMode() ? `/wallets/transactions/${id}` : "/trade/offer/",
    methods.PATCH,
    { status: status }
  );
};
